import React, { useState, useEffect } from "react";
import { Formik, Field, Form } from "formik";
import { fetchAPI } from "@/utility/NetworkUtils";
import { renderButton, renderMoneyField, renderCancelButton, renderDateField, renderSelectField, renderSelectFieldFilterable, renderTextAreaField, renderTextField, renderCheckField } from "@/shared/FormUtils";
import { isJaguar } from "@/utility/UserUtils";
import { Stack, Button, FormControlLabel, Switch } from "@mui/material";
import DropdownSection from "@/shared/DropdownSection";
import ReceivingListTrackingNumberForm from "@/items/form/ReceivingListTrackingNumberForm";
import ItemCardQuickViewModal from "@/items/ItemCardQuickViewModal";
import AddToCartForm from "@/items/form/AddToCartForm";
import Modal from "react-modal";
import { countries } from "countries-list";
import { object, string, number, date} from 'yup';
import { min } from "moment";
import InputAdornment from '@mui/material/InputAdornment';
import OrderUpdatedAtComponent from "../OrderUpdatedAtComponent";
import {DateTime} from "luxon";
const OrderForm = ({
  order,
  user
}) => {

  const isEditing = order.raw == false
  const editFieldsDisabled = !(order.status == 'draft' || order.status == 'ready')
  const [attemptedSubmit, setAttemptedSubmit] = useState(false)
  const [ orderItems, setOrderItems ] = useState(order.order_items || [])
  const [editingOrderQuanityId, setEditingOrderQuanityId] = useState(null)
  const [ showBulkTrackingNumberImport, setShowBulkTrackingNumberImport ] = useState(false);
  const [ addresses, setAddresses ] = useState([])
  
  useEffect(() => {
    fetchAddresses()
  },[])

  const fetchAddresses = () => {
    fetchAPI(`/webapi/shipping_addresses`, (json) => {
      if(!json.error) {
        setAddresses(json.shipping_addresses.filter((x,i,t)=> t.map(y=>y.id).indexOf(x.id) === i))
      }
    },{})
  }

  const fetchOrderItems = () => {
    fetchAPI(`/webapi/orders/${order.id}`, (json) => {
      if(!json.error) {
        setOrderItems(json.order.order_items)
      }
    },{})
  }

  const getInitialValues = (order) => {
    let values = {
      order: {
        title: order ? order.title : "",
        job_number: order ? order.job_number : "",
        notes: order ? order.notes : "",
        shipping_notes: order ? order.shipping_notes : "",
        additional_information_link: order ? order.additional_information_link : "",
        status: order ? order.status : "draft",
        shipping_address_id: order ? (order.shipping_address && order.shipping_address?.public ? order.shipping_address_id : null) : null,
        arrive_by: order ? order.arrive_by : null,
        maximum_shipping_cost: order ? order.maximum_shipping_cost : null,
        blind_shipping: order ? order.blind_shipping : false,
        blind_shipping_sender_name: order ? order.blind_shipping_sender_name : ""
      },
      shipping_address: order && order.shipping_address ? order.shipping_address||{public: false} : {
        venue_name: "",
        first_name: "",
        last_name: "",
        address_line_1: "",
        address_line_2: "",
        city: "",
        state_province: "",
        postal_code: "",
        country: "",
        phone: "",
        email: "",
        public: false
      },
      receiving_item_tracking_numbers: order ? order.order_tracking_numbers : [],
    }

    values.shipping_address.id = null
    return values
  }

  const renderOrderDetails =(formikProps) => {
    return (
      <div>
        {orderItems.map((orderItem) => {
          return renderItemRow(orderItem)
        })}
      </div>
    )
  }

  const renderItemRow = (orderItem) => {
    return (
      <div style={{
        borderBottom:"1px solid #e0e0e0"
        }} className="p-1 pl-0 flex align-items-center content-center items-center">
        <img className="w-[60px] h-[60px] object-cover" src={(orderItem?.item?.active_image||{}).image} />
        <div className="inline-block mt-[8px] ml-1">
        <ItemCardQuickViewModal
          item={orderItem.item}
          disableOrder={true}
          user={user}
          accessButton={(props)=>(
            <div {...props} className="flex-0 cursor-pointer text-nowrap inline-block overflow-hidden text-ellipsis text-blue-600 mr-2 text-base font-normal font-['Roboto'] leading-6 tracking-tight" >
              {orderItem?.item?.name}
            </div>
          )}
        />
        </div>
        <div class="inline-block text-black text-base font-normal font-['Roboto'] leading-6 tracking-tight">
          Qty. {orderItem.quantity}
        </div>
        {editFieldsDisabled ? "" : (
          <div className="text-[14px] text-[#3070E7] flex-1 text-right mt-[1px]">
            <a onClick={()=>setEditingOrderQuanityId(orderItem.id)} className="text-[#3070E7] cursor-pointer font-medium">
              EDIT QUANTITY
            </a> 
            {" | "}
            <a className="text-[#3070E7] cursor-pointer font-medium" onClick={(e) => {
              if(confirm("Are you sure you want to remove this item?")) {
                e.preventDefault()
                setOrderItems(orderItems.filter((oi) => oi.id != orderItem.id))
                fetchAPI(`/order_items/${orderItem.id}`, (json) => {
                
                }, {
                  method: "DELETE"
                })
              }
        
            }}>
              REMOVE
            </a>
          </div>
        )}
      </div>
    )
  }


  const getCountryOptions = () => {
    return Object.keys(countries).map((countryCode) => {
      return {
        value: countries[countryCode].name,
        label: countries[countryCode].name
      }
    }).sort((a, b) => {
      if(a.label == "United States") {
        return -1
      }
      if(b.label == "United States") {
        return 1
      }
      return a.label.toLowerCase() < b.label.toLowerCase() ? -1 : 1
    })
  }

  const getAddresses = () => {
    return addresses.sort((a,b) => a.venue_name.toLowerCase() < b.venue_name.toLowerCase() ? -1 : 1).map((address) => {
      return {
        value: address.id,
        label: address.venue_name,
        address: address
      }
    })
  }

  const renderAddressOption = (props, data) =>{
    return (
      <div {...props} className="hover:bg-[#e6e6e6]" style={{ alignItems: 'center', padding: '8px 12px' }}>
        <div className="block">
          <b>{data.label}</b>
        </div>
        <div  className="block">
          {data.address?.address_line_1} 
          <br/>
          {data.address?.address_line_2}
        </div>
        <div className="block">
          {[data.address?.city, data.address?.state_province, data.address?.postal_code].filter(x=>x).join(", ")}
        </div>
        <div className="block">
          {data.address?.country}
        </div>
      </div>
    )
  }
  
  const renderShippingDetails =(formikProps) => {
    const { values: { order: { shipping_address_id, blind_shipping }}} = formikProps
    const { status } = order
    console.log({
      order
    })
    console.log({
      blind_shipping
    })
    const shipping_address = shipping_address_id ? (addresses||[]).find(x => x.id == shipping_address_id) : null
    const addressFieldsDisabled = editFieldsDisabled || ( shipping_address && shipping_address?.public === true) || (!shipping_address && shipping_address_id)
    const fieldProperties = {
      inputProps: {
        min: 0,
        step: 0.01,
        placeholder: "Enter dollar amount",
        startAdornment: <InputAdornment position="start">$</InputAdornment>,
      },
      InputProps: {
        startAdornment: <InputAdornment position="start">$</InputAdornment>,
        step: "0.01",
        placeholder: "Enter dollar amount",
      },
      startAdornment: <InputAdornment position="start">$</InputAdornment>,
      placeholder: "Enter dollar amount",
      type: "number",
      step: "0.01"
    }
    return (
      <div>
        <Stack spacing={2}>
          {isJaguar(user) ? (
            renderSelectFieldFilterable("Choose Existing Address", "order[shipping_address_id]", getAddresses(), {
              disabled: editFieldsDisabled,
              fieldProperties: {
                renderOption: renderAddressOption,
              },
              onChange: (e) => {
                const address = addresses.find(x => x.id == e)

                formikProps.setFieldValue("shipping_address", address)
                formikProps.setFieldValue("order[shipping_address_id]", e)
              }
            })
          ):(
            <>
            </>
          )}

          {shipping_address_id && !editFieldsDisabled ? (
            <div>
              <Button  onClick={() => {
                formikProps.setFieldValue("order[shipping_address_id]", 0)
                formikProps.setFieldValue("shipping_address[public]", false)
                formikProps.setFieldValue("shipping_address", {
                  venue_name: "",
                  first_name: "",
                  last_name: "",
                  address_line_1: "",
                  address_line_2: "",
                  city: "",
                  state_province: "",
                  postal_code: "",
                  country: "",
                  phone: "",
                  email: "",
                  public: false
                })
              }}>
                Clear Address
              </Button>
              <Button  onClick={() => {
                formikProps.setFieldValue("order[shipping_address_id]", 0)
                formikProps.setFieldValue("shipping_address[public]", false)
                formikProps.setFieldValue("shipping_address[id]", null)
                formikProps.setFieldValue("shipping_address[venue_name]", `${formikProps.values.shipping_address?.venue_name} (Copy)`)
              }}>
                Edit Address
              </Button>
            </div>
          ):""}
          {!!shipping_address_id && isJaguar(user) && (
             <div className="text-black">
              Editing an address will create a copy of the address. If you mean to edit the master address, please go to <a href="/events/shipping_addresses">Address Book</a> and edit it there.
            </div>
          )}
         
          {!editFieldsDisabled && isJaguar(user) && (
            <div className="text-center">
              Or Create a New Address
            </div>
          )}

          {renderTextField("Destination Name", "shipping_address[venue_name]", {disabled: addressFieldsDisabled, required: true,
            fieldProperties: {
              inputProps: {
                maxLength: 35
              },
            }
          })}
          {renderTextField("Address Line 1", "shipping_address[address_line_1]", {disabled: addressFieldsDisabled, required: true})}
          {renderTextField("Address Line 2", "shipping_address[address_line_2]", {disabled: addressFieldsDisabled, required: false})}
          {renderSelectFieldFilterable("Country", "shipping_address[country]", getCountryOptions(), {disabled: addressFieldsDisabled, required: true})}
          <Stack spacing={2} direction="row">
            {renderTextField("City", "shipping_address[city]", {disabled: addressFieldsDisabled, required: true})}
            {formikProps?.values?.shipping_address?.country == "United States" ? renderSelectFieldFilterable("State", "shipping_address[state_province]", getStateOptions(), {disabled: addressFieldsDisabled, required: false}) : renderTextField("State/Province", "shipping_address[state_province]", {disabled: addressFieldsDisabled, required: false})}
            {renderTextField("Postal Code", "shipping_address[postal_code]", {disabled: addressFieldsDisabled, required: true})}
          </Stack>
          <Stack spacing={2} direction="row">
            {renderTextField("Recipient First Name", "shipping_address[first_name]", {disabled: addressFieldsDisabled, required: true})}
            {renderTextField("Recipient Last Name", "shipping_address[last_name]", {disabled: addressFieldsDisabled, required: true})}
          </Stack>
          <Stack spacing={2} direction="row">
            {renderTextField("Phone Number", "shipping_address[phone]", {disabled: addressFieldsDisabled, required: true})}
            {renderTextField("Email (Optional)", "shipping_address[email]", {disabled: addressFieldsDisabled})}
          </Stack>
          {isJaguar(user) && !addressFieldsDisabled && (
            <div>
              {renderCheckField("Add to Address Book", "shipping_address[public]", [], {disabled: addressFieldsDisabled})}
            </div>
          )}
          <div>
                    <FormControlLabel
            value="end"
            control={<Switch
              color="green"
              checked={blind_shipping}
              disabled={editFieldsDisabled}
              onChange={(e) => formikProps.setFieldValue("order[blind_shipping]", !!e.target.checked)}/>
            }
            label="Toggle if Blind Ship"
            labelPlacement="end"
          />
          </div>
          {blind_shipping && (
            <div>
              <div className="text-black mb-2">
                Enter the name you would like to appear for the sender. 
              </div>
              {renderTextField("Senders Name", "order[blind_shipping_sender_name]", {disabled: editFieldsDisabled, required: true})}
            </div>
          )}

          <div className="text-black">
            Select your requested delivery date. Please allow for 1-2 business days for order to be shipped.
          </div>
          <Stack spacing={2} direction="row">
            {renderDateField("Requested Delivery Date", "order[arrive_by]", [], {
              disabled: editFieldsDisabled,
              required: true,
              fieldProperties: {
                minDate: DateTime.now().plus({days: 2})
              }}
            )}
            {renderMoneyField( "Notify if shipping cost exceeds this amount", "order[maximum_shipping_cost]", {placeholder: "Enter dollar ammount", disabled: editFieldsDisabled, required: true,key: "rental_cost",fieldProperties: {...fieldProperties, key: "rental_cost"}})}
          </Stack>
          <FormControlLabel
            value="end"
            control={<Switch
              color="green"
              checked={formikProps.values.order.status != "draft"}
              disabled={status != "draft" && status != "ready"}
              onChange={(e) => formikProps.setFieldValue("order[status]", e.target.checked ? "ready" : "draft")}/>
            }
            label="Mark order as ready for shipping"
            labelPlacement="end"
          />
        </Stack>
      </div>
    )
  }

  const generateDefaultTrackingNumberObject = () => {
    return {
      tracking_number: "",
      status: "",
      courier: "",
      temporary_id: "temp-" + Math.random()* 100000000,
      tracking_data: {},
      tracking_response: {}
    }
  }

  const renderTrackingDetails =  (formikProps) => {

    return (
      <Stack spacing={2}>
        {(
          <>
            <div className="flex my-2">
              <a className="block " href="javascript:void(0)" onClick={(e) => {
                formikProps.setFieldValue("receiving_item_tracking_numbers", [...formikProps.values.receiving_item_tracking_numbers, generateDefaultTrackingNumberObject()])
              }}>
                + Add Tracking Number
              </a>

              <a className="block pl-4" href="javascript:void(0)" onClick={(e) => {
                setShowBulkTrackingNumberImport(!showBulkTrackingNumberImport)
              }}>
                {showBulkTrackingNumberImport ? "Cancel Bulk Import" : "Bulk Import Tracking Numbers"}
              </a>
            </div>
            {renderBulkTrackingNumberImport(formikProps)}
            {formikProps.values.receiving_item_tracking_numbers.map((tracking_number, index) => {
              return (
                <div className="mt-2">
                <ReceivingListTrackingNumberForm
                  key={"tracking-number-" + tracking_number.temporary_id}
                  formikProps={formikProps}
                  index={index}
                />
                </div>
              )
            })}
            {renderTextAreaField("Notes specific to Shipping/Receiving", "order[shipping_notes]", {multiline: true, rows: 5, minRows: 5, maxRows: 1000})}
          </>
        )}
          {renderTextField("Additional Tracking Link (Optional)", "order[additional_information_link]")}
          <div className="w-full md:w-1/2 mb-2">
            {renderSelectFieldFilterable("Order Status (Warehouse only)", "order[status]", [
              {label: "Draft", value: "draft"},
              {label: "Ready", value: "ready"},
              {label: "Locked", value: "locked"},
              {label: "Shipped", value: "shipped"},
            ], {
              disabled: order.status == "shipped"
            })}
          </div>
      </Stack>
    )
  }

  const renderBulkTrackingNumberImport = (formikProps) => {
    if(showBulkTrackingNumberImport) {
      return (
        <div className="form-group">
          {renderTextAreaField("Bulk Import Tracking Numbers (One Per Line)", "bulkTrackingNumber", {multiline: true, rows: 5, minRows: 5, maxRows: 1000})}
          <Stack direction="row" spacing={1} className="mt-1">
            <Button
              type="button"
              variant="contained"
              onClick={() => {
                const splitTrackingNumbers = (formikProps.values.bulkTrackingNumber||"").split("\n").filter(x=>x && x.length > 0);
                const newTrackingNumbers = Array(splitTrackingNumbers.length).fill(generateDefaultTrackingNumberObject()).map((x,i) => {
                  x = generateDefaultTrackingNumberObject()
                  x.tracking_number = splitTrackingNumbers[i]
                  return x
                })
                formikProps.values.receiving_item_tracking_numbers = formikProps.values.receiving_item_tracking_numbers.concat(newTrackingNumbers)
                formikProps.setFieldValue("receiving_item_tracking_numbers", formikProps.values.receiving_item_tracking_numbers)
                formikProps.setFieldValue("bulkTrackingNumber", "")
                setShowBulkTrackingNumberImport(false)
              }}
            >
              Import
            </Button>
            <Button
              type="button"
              variant="outlined"
              onClick={() => {
                setShowBulkTrackingNumberImport(false)
              }}
            >
              Cancel Bulk Import
            </Button>
          </Stack>
        </div>
      )
    }
  }

  const renderForm = (formikProps) => {
    return (
      <div>
        <Stack spacing={2} direction="column">
          <Stack spacing={2} direction="row">
            {renderTextField("Order Title (for reference only)", "order[title]", {required: true, disabled: editFieldsDisabled})}
            {isJaguar(user) && renderTextField("Job Number", "order[job_number]", {disabled: editFieldsDisabled, required: true})}
          </Stack>
          {renderTextAreaField("Notes", "order[notes]", {
            disabled: editFieldsDisabled
          })}
        </Stack>

        {(isEditing || orderItems.length > 0) && (
           <DropdownSection label="Order Details" defaultOpen>
            {renderOrderDetails(formikProps)}
           </DropdownSection>
        )}

        <DropdownSection label="Shipping Details" defaultOpen>
          {renderShippingDetails(formikProps)}
        </DropdownSection>
        {isJaguar(user) && (
          <DropdownSection label="Tracking Details" defaultOpen>
            {renderTrackingDetails(formikProps)}
          </DropdownSection>
        )}
        <div>
          {renderButtons(formikProps)}
        </div>
        <div>
          <OrderUpdatedAtComponent order={order}/>
        </div>

      </div>
    )
  }

  const renderButtons = (formikProps) => {
    return (
        <div className="mb-[20px]">
          <div>
            {renderErrors(formikProps)}
          </div>
          <Stack direction="row" spacing={2} className="mt-4">
            {renderCancelButton("Cancel", ()=>{
              window.location = "/orders"
            })}
            {
              renderButton( "Save", ()=>{
                setAttemptedSubmit(true)
                formikProps.handleSubmit()
              },{
                disabled: formikProps.isSubmitting,
                color: "green",
              })
            }

          </Stack>
        </div>
    )
  }

  const renderErrors = (formikProps) => {
    if(!attemptedSubmit) {
      return ""
    }
    let errorsArray = formikProps.errors.order ? Object.values(formikProps.errors.order) : []
    if(formikProps.errors.shipping_address) {
      errorsArray = errorsArray.concat(Object.values(formikProps.errors.shipping_address))
    }
    return (
      <div className="text-red-600 mt-2">
        {errorsArray.map((error, index) => {
          return (
            <div key={index}>
              {error}
            </div>
          )
        })}
      </div>
    )
  }

  const submitForm = (values, {
    setSubmitting
  }) => {
    fetchAPI(`/orders/${order.id}`, (json) => {
      setSubmitting(false)
      if (!json.error && !json.errors) {
        window.location = "/orders"
      } else {
        console.log({
          errors: json.errors
        })
      }
    }, {
      method: "PATCH",
      body: values
    })
  }

  const renderOrderQuantityModal = () => {
    if(editingOrderQuanityId) {
      const orderItem = orderItems.find((orderItem) => orderItem.id == editingOrderQuanityId)
      return (
        <Modal
          className="react-modal item-card-quick-view-modal"
          overlayClassName="react-modal-overlay"
          isOpen={true}
          onRequestClose={()=>setEditingOrderQuanityId(null)}
          contentLabel="Item Modal"
        >
          <AddToCartForm item={orderItem.item} orderItem={orderItem} onCancel={()=>setEditingOrderQuanityId(null)} onSubmit={()=>{
            setEditingOrderQuanityId(null)
            fetchOrderItems()
          }} />
        </Modal>
      )
    }
  }

  const validationSchema = object({
    order: object({
      title: string().required("Order Title is required"),
      job_number: string().when([], {
        is: () => isJaguar(user) && !editFieldsDisabled,
        then: (schema) => schema.required("Job Number is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
      arrive_by: date().when([], {
        is: () => !editFieldsDisabled,
        then: (schema) => schema.required("Arrive By Date is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
      maximum_shipping_cost: number().when([], {
        is: () => !editFieldsDisabled,
        then: (schema) => schema.required("Maximum Shipping Cost is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    shipping_address: object({
      first_name: string().required("First Name is required"),
      last_name: string().required("Last Name is required"),
      address_line_1: string().required("Address Line 1 is required"),
      city: string().required("City is required"),

      postal_code: string().required("Postal Code is required"),
      country: string().required("Country is required"),
      phone: string().required("Phone is required"),
    })
  });

  return (
    <>
     {renderOrderQuantityModal()}
      <Formik
        initialValues={getInitialValues(order)}
        onSubmit={submitForm}
        validationSchema={validationSchema}
        validateOnBlur={false}
        validateOnChange={true}
      >
      
      {(formikProps) => (
        <div className="row">
         
          <div className="col-xs-12 col-md-10">
            {renderForm(formikProps)}
          </div>

        </div>
      )}
  
      
    </Formik>
    </>
  )
};

export default OrderForm

const getStateOptions = () => {
  return [
    "Alabama",
    "Alaska",
    "Arizona",
    "Arkansas",
    "California",
    "Colorado",
    "Connecticut",
    "Delaware",
    "Florida",
    "Georgia",
    "Hawaii",
    "Idaho",
    "Illinois",
    "Indiana",
    "Iowa",
    "Kansas",
    "Kentucky",
    "Louisiana",
    "Maine",
    "Maryland",
    "Massachusetts",
    "Michigan",
    "Minnesota",
    "Mississippi",
    "Missouri",
    "Montana",
    "Nebraska",
    "Nevada",
    "New Hampshire",
    "New Jersey",
    "New Mexico",
    "New York",
    "North Carolina",
    "North Dakota",
    "Ohio",
    "Oklahoma",
    "Oregon",
    "Pennsylvania",
    "Rhode Island",
    "South Carolina",
    "South Dakota",
    "Tennessee",
    "Texas",
    "Utah",
    "Vermont",
    "Virginia",
    "Washington",
    "West Virginia",
    "Wisconsin",
    "Wyoming"
  ].map((state) => {
    return {
      value: state,
      label: state
    }
  })

}